<template>
	<div v-for="feed in feeds">
		<a :href="feed.url">{{ feed.label }}</a>
	</div>
</template>

<script setup>
import { defineProps, ref } from 'vue' 

const props = defineProps(['podcast'])

const feeds = ref([
	{
		name: 'apple-podcasts',
		label: 'Apple Podcasts',
		url: 'podcast://' + route('podcasts.rss', props.podcast)
	},
	{
		name: 'google-podcasts',
		label: 'Google Podcasts',
		url: 'google-podcasts://' + route('podcasts.rss', props.podcast)
	},
	{
		name: 'downcast',
		label: 'Downcast',
		url: 'downcast://' + route('podcasts.rss', props.podcast)
	},
])
</script>
